/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/elysion/"

const elysion: CommunityData = {
  code: "elysion",
  inviteCode: "elysion",
  name: "Elysion",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ely-101`,
  socials: {},
  waitlist: true,
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `https://media.werz.at/community-assets/elysion/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/elysion/mobile-landing-background.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `https://media.werz.at/community-assets/elysion/new-logo.png`,
        mobile: `https://media.werz.at/community-assets/elysion/new-logo.png`,
        style: "hidden sm:block sm:w-[94px] sm:h-[129px] !invert",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['JostSemiBold'] text-[28px] leading-[120%] text-[#ffffff]",
      text: "font-['InterRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['InterRegular'] text-[16px] leading-[120%] p-4 bg-[#ffffff] text-[#000000] rounded-[8px] cursor-pointer w-fit",
      input: {
        base: "font-['InterRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['InterRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title: "font-['JostSemiBold'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: "https://media.werz.at/community/icon/cmgrvr4ka00009k5483mszkiw.jpg?uploadTime=1760537546030&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[174px] h-[45px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#6d6d6d]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['JostRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[18px] py-[18px] !text-[#000000] font-['InterRegular'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff]",
      separator: "border-[#ffffff]",
      item: "font-['JostRegular'] text-[16px] text-[#ffffff] uppercase text-left gap-x-[10px] text-opacity-50 border-b border-[#ffffff] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#a7a7a7] rounded-[24px] !pb-8",
      titles: "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a7a7a7] font-['InterRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['JostSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['InterRegular'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['JostSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['JostSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile:
        "https://media.werz.at/community-assets/elysion/mobile-landing-background.mp4?type=video",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#a7a7a7]",
        name: "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#FFF",
        button:
          "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#a7a7a7] rounded-[24px] text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          title:
            "font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center text-center",
          button:
            "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          duration: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          name: "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#FFF",
          media: "overflow-hidden m-2 border border-[#a7a7a7] rounded-[24px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          name: "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#6d6d6d] rounded-[8px] text-[#000000] font-['JostSemiBold'] text-[16px] uppercase leading-[17.6px] text-center",
          duration: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          location: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          button:
            "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#a7a7a7]",
            name: "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[17.6px] text-[14px] text-left",
            link: "text-[#a7a7a7] font-['InterRegular'] text-[14px] text-left",
            status:
              "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[110%] text-[14px] text-left",
            button:
              "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#a7a7a7] rounded-[24px] text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          name: "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFF",
          created: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          media: "overflow-hidden m-2 border border-[#a7a7a7] rounded-[24px]",
        },
        seeAllNews:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#a7a7a7] rounded-[24px] text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          coverUrl: "overflow-hidden m-2 border border-[#a7a7a7] rounded-[24px]",
          duration: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          liveType: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#000000",
          start: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
          title:
            "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#a7a7a7] rounded-[24px] text-[#ffffff] font-['InterRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#a7a7a7] rounded-[24px]",
          name: "text-[#ffffff] font-['JostSemiBold'] uppercase leading-[22px] text-[16px] text-left",
          triangleIconColor: "#FFF",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#a7a7a7] rounded-[24px]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#a7a7a7] font-['InterRegular'] text-[12px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#a7a7a7] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#a7a7a7]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['JostSemiBold'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#a7a7a7] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['InterRegular'] !text-[16px] text-left",
        questions: "text-[14px] text-left leading-[130%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header:
          "text-[#ffffff] font-['JostSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header:
          "text-[#ffffff] font-['JostSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['JostSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['JostSemiBold'] text-[24px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#a7a7a7] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['JostSemiBold'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#a7a7a7] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price:
            "text-[#a7a7a7] font-['JostSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          quantity: "text-[#000000] font-['InterRegular'] text-[14px] text-left",
          status:
            "text-[#a7a7a7] font-['JostSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#ffffff] rounded-[8px] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default elysion
